import { useMessaging } from '@ucc/admin-messaging'
import mixpanel from 'mixpanel-browser'

import config from 'config'

const track =
  config.ENV === 'production'
    ? (event, data) => mixpanel.track(event, data)
    : (event, data) => console.log('[ANALYTICS]', event, data)

const useCentralizedMixpanel = () =>
  useMessaging('analytics-track', (payload: unknown) => {
    if (payload && typeof payload === 'object' && 'event' in payload) {
      const data = {
        ...('data' in payload && typeof payload.data === 'object' ? payload.data : {}),
      }
      track(payload.event, data)
    }
  })

export default useCentralizedMixpanel
